/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_home_hero_title_2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every Player`)
};

const zh_hans1_home_hero_title_2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`安全验证`)
};

const zh_hant1_home_hero_title_2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`安全驗證`)
};

const fr_home_hero_title_2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`chaque joueur`)
};

const de_home_hero_title_2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`jeden Spieler`)
};

const ja_home_hero_title_2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`安全な認証を`)
};

const ko_home_hero_title_2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`안전한 인증`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const home_hero_title_2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.home_hero_title_2(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("home_hero_title_2", locale)
	if (locale === "en") return en_home_hero_title_2(inputs)
	if (locale === "zh-Hans") return zh_hans1_home_hero_title_2(inputs)
	if (locale === "zh-Hant") return zh_hant1_home_hero_title_2(inputs)
	if (locale === "fr") return fr_home_hero_title_2(inputs)
	if (locale === "de") return de_home_hero_title_2(inputs)
	if (locale === "ja") return ja_home_hero_title_2(inputs)
	return ko_home_hero_title_2(inputs)
};